import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { RouterLink } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { CapitalizeFirstLetterPipe } from './pipes/capitalize-first-letter.pipe';
import { CapitalizeInitialsPipe } from './pipes/capitalize-initials.pipe';
import { InfoboxComponent } from './components/infobox/infobox.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PhonePipe } from './pipes/phone.pipe';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HoverModalComponent } from './components/hover-modal/hover-modal.component';
import { HoverModalInformationDealComponent } from '@shared/components/hover-modal/hover-modal-information-deal.component';
import { InformationReportBankComponent } from '@shared/components/information-report-bank/information-report-bank.component';

@NgModule({
  declarations: [
    CapitalizeFirstLetterPipe,
    CapitalizeInitialsPipe,
    InfoboxComponent,
    NavbarComponent,
    PaginationComponent,
    PhonePipe,
    SidebarComponent,
    HoverModalComponent,
    HoverModalInformationDealComponent,
    InformationReportBankComponent,
  ],
  imports: [
    RouterLink,
    CommonModule,
    PaginationModule,
    CollapseModule,
    BsDropdownModule,
    MatDialogModule,
    MatButtonModule,
  ],
  exports: [
    CapitalizeFirstLetterPipe,
    CapitalizeInitialsPipe,
    InfoboxComponent,
    NavbarComponent,
    PaginationComponent,
    PhonePipe,
    SidebarComponent,
  ],
})
export class SharedModule {}
